import React from 'react';

const ChatMessage = ({ message, sender, imageUrl }) => {
  const isBot = sender === 'bot';
  
  // Format image URL to use CloudFront CDN if needed
  const formattedImageUrl = imageUrl && !imageUrl.startsWith('https://') 
    ? `https://d2rgo8dacqxio8.cloudfront.net/${imageUrl}` 
    : imageUrl;

  return (
    <div className={`flex mb-4 ${isBot ? 'justify-start' : 'justify-end'} w-full px-2`}>
      <div 
        className={`max-w-[90%] md:max-w-md rounded-lg ${
           formattedImageUrl && !message 
      ? ''
      : isBot 
            ? 'bg-gray-200 text-gray-800 rounded-bl-none px-4 py-2' 
            : 'bg-indigo-600 text-white rounded-br-none px-4 py-2'
        }`}
      >
        {formattedImageUrl && (
          <div className="mb-2">
            <a 
              href={formattedImageUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="block"
            >
              <img 
                src={formattedImageUrl} 
                alt="Uploaded content" 
                className="max-w-full h-auto rounded-md object-cover max-h-40 cursor-pointer hover:opacity-90 transition-opacity"
              />
            </a>
            <p className="text-xs text-gray-500 mt-1">Click image to view full size</p>
          </div>
        )}
        
        {message && <p className="text-sm break-words">{message}</p>}
      </div>
    </div>
  );
};

export default ChatMessage;  


